// This file should contain properties and functions exposed under the window.dk namespace for use across other JavaScript files
(function (win, $) {
    'use strict';

    var breakpoints =
        {
            mobile: {
                max: 649
            },
            tablet: {
                min: 650,
                max: 1024
            },
            desktop: {
                min: 1025,
                max: 1439
            },
            xl: {
                min: 1440
            }
        },
        rootElt = document.getElementsByTagName('html')[0],
        rootClasses = rootElt ? rootElt.getAttribute('class') : '',
        rootHasAuthoringClass = rootClasses.match(/(^|\s)experienceeditor(\s|$)/ig) ? true : false,
        rootHasEditingClass = rootClasses.match(/(^|\s)editmode(\s|$)/ig) ? true : false,
        isSitecoreScriptAuthoring = (win.Sitecore && win.Sitecore.PageModes) ? true : false,
        isSitecoreScriptEditing = (isSitecoreScriptAuthoring && win.Sitecore.PageModes.PageEditor) ? true : false,
        bodyStyle = document.body.style;

    function generateId(prefix) {
        var id;
        function gen() {
            prefix = typeof prefix === 'string' ? prefix : 'id-';
            return prefix + Math.floor(Math.random() * 100000).toString(26);
        }
        do {
            id = gen();
        } while (document.getElementById(id));
        return id;
    }

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    function setPageModified() {
        try {
            win.Sitecore.PageModes.PageEditor.setModified(true);
        } catch (ex) {
            // Do nothing
        }
    }

    function toTabletPx(px) {
        return px * 0.85;
    }

    function getBaseFontSize() {
        return parseFloat($('html').css('font-size'));
    }

    function remToPx(rem) {
        return rem * (Math.round(getBaseFontSize()) || 14);
    }

    function getWindowSize() {
        var width = breakpoints.mobile.max + 1;
        if ((win && win.innerWidth) || (screen && screen.width)) {
            width = win.innerWidth || screen.width;
        }
        return width;
    }

    function isWindowSizeBetween(min, max) {
        var size = Math.round(getWindowSize());
        return (min || 0) <= size && (max > 0 ? (size <= max) : true);
    }

    function getResponsiveObj() {
        var baseFont = getBaseFontSize();
        return {
            windowSize: getWindowSize(),
            baseFontSize: baseFont,
            baseFontSizeRounded: Math.round(baseFont),
            breakpoints: $.extend(true, {}, breakpoints),
            isMobile: isWindowSizeBetween(0, breakpoints.mobile.max),
            isTablet: isWindowSizeBetween(breakpoints.tablet.min, breakpoints.tablet.max),
            isDesktop: isWindowSizeBetween(breakpoints.desktop.min),
            isDesktopSmall: isWindowSizeBetween(breakpoints.desktop.min, breakpoints.desktop.max),
            isDesktopLarge: isWindowSizeBetween(breakpoints.xl.min)
        };
    }

    win.dk = win.dk || {};
    $.extend(true, win.dk, {
        isAuthor: rootHasAuthoringClass || isSitecoreScriptAuthoring,
        isEditing: rootHasEditingClass || isSitecoreScriptEditing,
        generateId: generateId,
        debounce: debounce,
        setModified: setPageModified,
        toTabletPx: toTabletPx,
        remToPx: remToPx,
        getWindowSize: getWindowSize,
        isWindowSizeBetween: isWindowSizeBetween,
        responsive: $.extend(true, {}, getResponsiveObj())
    });

    // Custom browser feature detection
    if (!('backgroundBlendMode' in bodyStyle)) {
        // No support for background-blend-mode
        rootElt.className += ' no-backgroundblendmode';
    }
    if ('webkitLineClamp' in bodyStyle) {
        // Supports -webkit-line-clamp
        rootElt.className += ' webkitlineclamp';
    }

    // On document loaded
    $(function () {
        // Recalculate responsive values on screen size change
        $(win).on('DOMContentLoaded load resize orientationchange', function () {
            $.extend(true, win.dk, {
                responsive: $.extend(true, {}, getResponsiveObj())
            });
        });

        // Translate data classes into attributes
        // data-attribute-name_value-with_space
        $('[class*="data-"]').each(function () {
            var $me = $(this),
                cls = ($me.attr('class') || '').split(/\s+/),
                attrs = {};
            $.each(cls, function (i, v) {
                var m = v.match(/^(data-[^_]+)(?:_+(.*))?/i) || [],
                    attr = (m[1] || '').toLowerCase(),
                    val = (m[2] || '').replace(/_+/g, ' ').replace(/^ +| +$/g, '');
                if (attr) {
                    attrs[attr] = val;
                }
            });
            $me.attr(attrs);
        });

        // Add the url-break class to links where the link text consists of a URL to avoid page overflow
        // Disable per link using the .no-url-break class or data-no-break attribute
        // Disable globally by adding the data-no-auto-break-links attribute on the root html element
        $('html:not([data-no-auto-break-links]) main a[href]:not(.url-ellipsis,.no-url-break):not([data-no-break])').filter(function () {
            return $(this).text().match(/^\s*(https?:|www\.)/i);
        }).addClass('url-break');
    });
})(window, window.jQuery);
